export default {
  portfolio: {
    title: 'Unsere Projekte',
    projects: {
      ai_valuation: 'KI-Immobilienbewertung',
      price_prediction: 'Preisprognosen',
      district_analysis: 'Marktanalyse nach Stadtteilen',
      report_automation: 'Automatisierung von Berichten',
      developer_api_integration: 'Integration mit Entwickler-APIs',
      investment_index: 'Indizes der Investitionsattraktivität'
    }
  }
}
